import { render } from "./FloatingMessage.vue?vue&type=template&id=a4f8c474"
import script from "./FloatingMessage.vue?vue&type=script&lang=js"
export * from "./FloatingMessage.vue?vue&type=script&lang=js"

import "./FloatingMessage.vue?vue&type=style&index=0&id=a4f8c474&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__